import { LeagueConfigsFragment } from '@/api/leagues/query.generated';
import { League, ProjectionType } from '@/types/api.generated';

export const ALL_POSITIONS = 'All';

export const Filters = {
    Position: 'Position',
    Projection: 'Projection',
    SocialLineups: 'SocialLineups',
    Preview: 'Preview',
} as const;

export type FilterType = (typeof Filters)[keyof typeof Filters];

export const PROJECTIONS_TAB = {
    title: 'Projections',
    id: 'projections',
    filterType: Filters.Projection,
    testID: 'filter-tab-projections',
} as const;
export const PLAYERS_TAB = {
    title: 'Players',
    id: 'players',
    filterType: Filters.Position,
    testID: 'filter-tab-players',
} as const;
// "Fights" behave similar to "Position" filter, so we can use the same filter type
export const UFC_FIGHTS_TAB = {
    title: 'Fights',
    id: 'players',
    filterType: Filters.Position,
    testID: 'filter-tab-fights',
} as const;
export const SOCIAL_LINEUPS_TAB = {
    title: 'Lineups',
    id: 'lineups',
    filterType: Filters.SocialLineups,
    testID: 'filter-tab-lineups',
} as const;
export const MATCH_PREVIEW_TAB = {
    title: 'Preview',
    id: 'match-preview',
    filterType: Filters.Preview,
    testID: 'filter-tab-match-preview',
} as const;

export const isFilterBarHidden = (filterType: FilterType, hasPositionFilters: boolean | undefined): boolean =>
    (filterType === Filters.Position && !hasPositionFilters) ||
    filterType === Filters.SocialLineups ||
    filterType === Filters.Preview;

export const FILTER_MODES_TABS = [PROJECTIONS_TAB, PLAYERS_TAB];
export const UFC_FILTER_MODES_TABS = [PROJECTIONS_TAB, UFC_FIGHTS_TAB];

export const nonRegularProjectionTypes: ProjectionType[] = Object.values(ProjectionType).filter(
    it => it !== ProjectionType.Regular
);

export const getPositionFilters = (league: League, leagues: LeagueConfigsFragment[]) => {
    const activeLeague = leagues.find(it => it.league === league);

    if (!activeLeague) {
        return;
    }

    return activeLeague.positionFilters;
};
